export default "__VITE_ASSET__dae69476__"